<template>
  <section class="page-section" v-loading="pageLoading">
        <el-form size="small" label-width="0px" class="content-form">
          <template v-for="(record, recordIndex) in listData">
            <div class="level-item" :key="recordIndex">
              <el-form-item label="" required :show-message="false">
                <div class="content">
                  <div class="item">
                    <div class="label">顾客等级</div>
                    <div class="cont">
                      <el-input v-model="record.levelName" class="w60"></el-input>
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">等级名称</div>
                    <div class="cont">
                      <el-input v-model="record.name" class="w80"></el-input>
                    </div>
                  </div>
                  <div class="item" style="width: 200px;">
                    <div class="label">消费金额</div>
                    <div class="cont">
                      <el-input v-model="record.start" class="w70"></el-input>
                      <template v-if="recordIndex == listData.length - 1">
                        <span class="sep">元以上</span>
                      </template>
                      <template v-else>
                        <span class="sep">元&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                        <el-input v-model="record.end" class="w70"></el-input>
                        <span class="sep">元</span>
                      </template>
                    </div>
                  </div>
                  <template v-if="recordIndex < listData.length - 1">
                    <div class="item" style="width: 410px;">
                      <div class="label">等级晋升条件</div>
                      <div class="cont">
                        <span class="sep">累计消费</span>
                        <el-input v-model="listData[recordIndex + 1].start" class="w70" disabled></el-input>
                        <span class="sep">元 + 邀请</span>
                        <el-input v-model="record.inviteNum" class="w70"></el-input>
                        <span class="sep">位消费用户升</span>
                        <el-input v-model="listData[recordIndex + 1].levelName" class="w70" disabled></el-input>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="content">
                  <div class="item">
                    <div class="label">邀请注册用户</div>
                    <div class="cont">
                      <el-input v-model="record.sharePoint" class="w60"></el-input>
                      <span class="sep">分享积分</span>
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">换取消费分比例</div>
                    <div class="cont">
                      <el-input v-model="record.shoppingPercent" class="w60"></el-input>
                      <span class="sep">%</span>
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">换取分享分比例</div>
                    <div class="cont">
                      <el-input v-model="record.sharePercent" class="w60"></el-input>
                      <span class="sep">%</span>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </template>
          <div class="btn-wrap">
            <el-button type="primary" size="small" :loading="submitLoading" @click="handleSave">保存</el-button>
            <el-button size="small" type="default" plain @click="handleback">取消</el-button>
          </div>
        </el-form>
      </section>
</template>

<script>
import { COMMON, userLevelList, userLevelSave } from '@/common/api'

export default {
  name: 'userLevelDetail',
  data() {
    return {
      COMMON,
      pageLoading: true,

      listData: [],
      submitLoading: false,

      requestNum: 0
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * [getList description] 获取列表
     * @return {[type]} [description]
     */
    getList: function () {
      this.pageLoading = true;

      let params = {}

      userLevelList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.pageLoading = false;

          this.listData = data || []
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        console.log(error)
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSave description] 保存数据
     * @return {[type]} [description]
     */
    handleSave: function (formName) {
      let listData = JSON.parse(JSON.stringify(this.listData))
      for (let i = 0; i < listData.length; i++) {
        let row = listData[i]
        if (!row.levelName) {
          this.$message.error('请输入顾客等级');
          this.$forceUpdate()
          return false;
        }
        if (!row.name) {
          this.$message.error('请输入' + row.levelName + '的会员名称');
          this.$forceUpdate()
          return false;
        }
        if (row.start === '') {
          row.start = ''
          this.$message.error('请输入' + row.levelName + '的起始消费金额');
          this.$forceUpdate()
          return false;
        }
        if (row.end === '') {
          row.end = ''
          this.$message.error('请输入' + row.levelName + '的结束消费金额');
          this.$forceUpdate()
          return false;
        }
        if (row.inviteNum === '') {
          row.inviteNum = ''
          this.$message.error('请输入' + row.levelName + '的消费用户邀请人数');
          this.$forceUpdate()
          return false;
        }
        if (row.sharePoint === '') {
          row.sharePoint = ''
          this.$message.error('请输入' + row.levelName + '的分享积分');
          this.$forceUpdate()
          return false;
        }
        if (row.shoppingPercent === '') {
          row.shoppingPercent = ''
          this.$message.error('请输入' + row.levelName + '的换取消费分比例');
          this.$forceUpdate()
          return false;
        }
        if (row.sharePercent === '') {
          row.sharePercent = ''
          this.$message.error('请输入' + row.levelName + '的换取分享分比例');
          this.$forceUpdate()
          return false;
        }
      }

      this.submitLoading = true;

      for (let i = 0; i < listData.length; i++) {
        this.doRequest(listData[i])
      }
    },
    doRequest(row) {
      let params = row

      userLevelSave(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.requestNum += 1;
          if (this.requestNum == this.listData.length) {
            this.submitLoading = false;
            this.requestNum = 0
            this.$message({ message: '保存成功', type: 'success' });
          }
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.submitLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleback description] 取消-返回列表
     * @return {[type]}          [description]
     */
    handleback: function () {
      this.$router.push('/agent/user/list');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.level-item {
  margin: 0 10px;
  border-bottom: 1px solid rgba(#000, .15);

  &+.level-item {
    margin-top: 10px;
  }

  .title {
    font-size: 14px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 500;
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;

    .item {

      &+.item {
        margin-left: 20px;
      }

      .cont {
        .sep {
          margin: 0 4px;
        }
      }
    }
  }
}

.btn-wrap {
  margin: 20px 10px;
}
</style>
